import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { css } from '@patternfly/react-styles';
import { keyHandler } from '../../helpers/util';
import { DropdownPosition, DropdownArrowContext, DropdownContext } from './dropdownConstants';
export var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu() {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).apply(this, arguments));
    _this.refsCollection = [];

    _this.childKeyHandler = function (index, innerIndex, position) {
      var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      keyHandler(index, innerIndex, position, _this.refsCollection, _this.props.isGrouped ? _this.refsCollection : React.Children.toArray(_this.props.children), custom);
    };

    _this.sendRef = function (index, nodes, isDisabled, isSeparator) {
      _this.refsCollection[index] = [];
      nodes.map(function (node, innerIndex) {
        if (!node) {
          _this.refsCollection[index][innerIndex] = null;
        } else if (!node.getAttribute) {
          // eslint-disable-next-line react/no-find-dom-node
          _this.refsCollection[index][innerIndex] = ReactDOM.findDOMNode(node);
        } else if (isDisabled || isSeparator) {
          _this.refsCollection[index][innerIndex] = null;
        } else {
          _this.refsCollection[index][innerIndex] = node;
        }
      });
    };

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;

      if (autoFocus) {
        // Focus first non-disabled element
        var focusTargetCollection = this.refsCollection.find(function (ref) {
          return ref && ref[0] && !ref[0].hasAttribute('disabled');
        });
        var focusTarget = focusTargetCollection && focusTargetCollection[0];

        if (focusTarget && focusTarget.focus) {
          focusTarget.focus();
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // reset refsCollection before updating to account for child removal between mounts
      this.refsCollection = [];
      return true;
    }
  }, {
    key: "extendChildren",
    value: function extendChildren() {
      var _this$props = this.props,
          children = _this$props.children,
          isGrouped = _this$props.isGrouped;

      if (isGrouped) {
        var index = 0;
        return React.Children.map(children, function (groupedChildren) {
          var group = groupedChildren;
          return React.cloneElement(group, Object.assign({}, group.props && group.props.children && {
            children: group.props.children.constructor === Array && React.Children.map(group.props.children, function (option) {
              return React.cloneElement(option, {
                index: index++
              });
            }) || React.cloneElement(group.props.children, {
              index: index++
            })
          }));
        });
      }

      return React.Children.map(children, function (child, index) {
        return React.cloneElement(child, {
          index: index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          isOpen = _a.isOpen,
          position = _a.position,
          children = _a.children,
          component = _a.component,
          isGrouped = _a.isGrouped,
          openedOnEnter = _a.openedOnEnter,
          props = __rest(_a, ["className", "isOpen", "position", "children", "component", "isGrouped", "openedOnEnter"]);

      return React.createElement(DropdownArrowContext.Provider, {
        value: {
          keyHandler: this.childKeyHandler,
          sendRef: this.sendRef
        }
      }, component === 'div' ? React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            menuClass = _ref.menuClass;
        return React.createElement("div", {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          onClick: function onClick(event) {
            return onSelect && onSelect(event);
          }
        }, children);
      }) : isGrouped && React.createElement(DropdownContext.Consumer, null, function (_ref2) {
        var menuClass = _ref2.menuClass,
            menuComponent = _ref2.menuComponent;
        var MenuComponent = menuComponent || 'div';
        return React.createElement(MenuComponent, Object.assign({}, props, {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu"
        }), _this2.extendChildren());
      }) || React.createElement(DropdownContext.Consumer, null, function (_ref3) {
        var menuClass = _ref3.menuClass,
            menuComponent = _ref3.menuComponent;
        var MenuComponent = menuComponent || component;
        return React.createElement(MenuComponent, Object.assign({}, props, {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu"
        }), _this2.extendChildren());
      }));
    }
  }]);

  return DropdownMenu;
}(React.Component);
DropdownMenu.defaultProps = {
  className: '',
  isOpen: true,
  openedOnEnter: false,
  autoFocus: true,
  position: DropdownPosition.left,
  component: 'ul',
  isGrouped: false
};